// MVP API 의 광고 보상 티켓 창구 (api/internal/httpapi/adreward.go). 배포는 Vercel rewrite, 로컬은 Vite proxy 가 /api 를 API 서버로 넘긴다.
// 경로에 ads 가 없다 — 광고 차단기 필터가 `/ads/` 요청을 막아, 광고를 본 유저의 청구가 사라질 수 있다
import { z } from 'zod';

const TIMEOUT_MS = 15_000;

const Issued = z.object({ ticket: z.string().min(1) });
const Claimed = z.object({ granted: z.literal(true) });

async function post(path: string, token: string, body: unknown): Promise<unknown> {
  try {
    const res = await fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(body),
      signal: AbortSignal.timeout(TIMEOUT_MS),
    });
    return res.ok ? await res.json() : null;
  } catch {
    return null;
  }
}

/** 광고 직전에 부른다. 티켓 id, 실패면 null */
export async function issueTicket(endpoint: string, token: string): Promise<string | null> {
  const issued = Issued.safeParse(await post(endpoint, token, {}));
  return issued.success ? issued.data.ticket : null;
}

/** 끝까지 본 뒤에 부른다. 서버가 보상을 줬으면 true */
export async function claimTicket(endpoint: string, token: string, ticket: string): Promise<boolean> {
  return Claimed.safeParse(await post(`${endpoint}/claim`, token, { ticket })).success;
}
